module.exports = __webpack_public_path__ + "img/post.5f76c606.svg";